export const referralsRewardItems = [
  {
    name: "KFC",
    tag: "GHS 100",
    id: "kfc-voucher",
    points: 2500,
    image: "/assets/images/kfcmw.jpg",
  },
];
